import React from "react";
import { ServiceAttributeCategory } from "../../../../types/types";
import { ServiceFormValue } from "../serviceFormTypes";
interface AttributesStepProps {
  value: ServiceFormValue;
  attributeCategories: ServiceAttributeCategory[];
  onAttributeToggle: (id: number) => void;
}

export function ServiceAttributesStep({
  value,
  attributeCategories,
  onAttributeToggle,
}: AttributesStepProps) {
  return (
    <div className="card">
      <div className="card-title">Service Attributes</div>
      <div className="form-help-text">
        Select who this service supports and any relevant access or delivery
        attributes.
      </div>
      <div className="service-attribute-grid">
        {attributeCategories.map((category) => (
          <section
            key={category.serviceAttributeCategoryId}
            className="service-attribute-category"
          >
            <div className="card-form-section-title">{category.name}</div>
            {category.description && (
              <div className="field-hint">{category.description}</div>
            )}
            <div className="option-group">
              {category.attributes.map((attribute) => (
                <label
                  key={attribute.serviceAttributeId}
                  className="option-item"
                >
                  <input
                    type="checkbox"
                    checked={value.serviceAttributeIds.includes(
                      attribute.serviceAttributeId,
                    )}
                    onChange={() =>
                      onAttributeToggle(attribute.serviceAttributeId)
                    }
                  />
                  <span>
                    {attribute.name}
                    {attribute.description && (
                      <small>{attribute.description}</small>
                    )}
                  </span>
                </label>
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
